import { TFunction } from "i18next";

export const tableHeader = [
  "id",
  "nameRu",
  "status",
  "createdAt",
  "updatedAt",
  "createdBy",
  "writtenBy",
];

export const selectStatus = (t: TFunction) => [
  { value: "active", label: t("reports_list.active") },
  { value: "removed", label: t("reports_list.removed") },
];
